// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterChannels_root__vxcoV"};